export const FOOTER_URL = {
  COOKIES: '#',
  NOTICE: 'https://www.helix.com/pages/notice-of-privacy-practices',
  PRIVACY: 'https://www.helix.com/privacy-policy',
  TERMS: '#',
};

export const EMAIL = ' support.helixbuilder@helix.com';
